module.exports = __webpack_public_path__ + "img/3.0e07dfc8.jpg";